import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetController} from "../../standings-widget.controller";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {StandingsWidgetCompetitorWinnerDescription} from "./standings-widget.competitor.winner-description";
import {StandingsWidgetCompetitorDestination} from "./standings-widget.competitor.destination";
import {Ellipsis} from "../../../../core/components/misc/ellipsis/ellipsis";
import {TableCell} from "../../../../core/components/table/table-cell";
import {StandingsWidgetRowViewModel} from "../../models/standings-widget.row-view-model";
import {StandingsWidgetLiveScoreBadge} from "../elements/standings-widget.live-score.badge";
import {ACTION_TYPES} from "../../../../core/consts";
import {APP} from "../../../../core/app/consts";
import {CompetitorViewModel} from "../../../../domain/common/competitor/models/competitor-view-model";
import {Link} from "../../../../core/components/link/link";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";

export class StandingsWidgetCompetitorNameProps extends BaseProps {
  controller: StandingsWidgetController;
  row: StandingsWidgetRowViewModel;
}

export const StandingsWidgetCompetitorName = observer(({
                                                         row,
                                                         source,
                                                         controller,
                                                         firstCellWidth
                                                       }: StandingsWidgetCompetitorNameProps) => {
  const {competitor} = row;
  const {state} = controller;
  const { currentLinkModel, onlyMajorColumns} = state;
  const winnerDescriptionProps = {row, controller}
  const {id, linkModel, domainModel, sport, name} = competitor;

  const offset = row.liveGame ? STANDINGS_WIDGET.CELLS.live : 0;
  const width = row.liveGame ? firstCellWidth : `calc(100% - ${offset}px)`;
  const ellipsisWidth = firstCellWidth - offset > 0 ? firstCellWidth - offset : `calc(100% - ${offset}px)`;

  const ellipsisProps = {
    text: name,
    numOfMaxLines: 1,
    className: classNames(styles.competitor_name_text),
    style: onlyMajorColumns ? {width: 72} : {
      width: ellipsisWidth,
      maxWidth: ellipsisWidth
    }
  };

  const firstCellStyle = {
    style: firstCellWidth ? {
      minWidth: width,
      maxWidth: width
    } : {}
  }

  const onCompetitorClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[CompetitorViewModel.name],
      currentLinkModel: currentLinkModel,
      sportTypeId: sport.id,
      source
    });

    return true;
  }

  const linkProps = {
    className: classNames(styles.competitor_info, {[styles.only_major]: onlyMajorColumns}),
    onClick: () => onCompetitorClick(),
    model: linkModel,
    routeProps: {
      dataSource: {
        entity: domainModel
      }
    }
  }

  return (
    <TableCell className={classNames(styles.competitor_name)} {...firstCellStyle}>
      <Link {...linkProps}>
        <Ellipsis {...ellipsisProps}/>
        <StandingsWidgetCompetitorWinnerDescription {...winnerDescriptionProps}/>
        {
          onlyMajorColumns  ? null :
              <StandingsWidgetCompetitorDestination row={row} firstCellWidth={firstCellWidth} onlyMajorColumns={onlyMajorColumns}/>
        }
      </Link>
      <StandingsWidgetLiveScoreBadge controller={controller} liveGame={row.liveGame}/>
    </TableCell>
  )
});
